// The entire elevation system — DESIGN_LANGUAGE.md §2.3. Two named shadows,
// [lightValue, darkValue] pairs; everything not float/overlay casts nothing.
// The dark overlay half is byte-equivalent to the previously dominant modal
// shadow (0 8px 32px rgba(0,0,0,0.45)), so the largest existing family has
// zero visual delta. Mirrored in brand designSystem/shadow.js.
export default {
  float: ['0 2px 12px black.08', '0 4px 16px black.35'],
  overlay: ['0 8px 32px black.12', '0 8px 32px black.45'],
  // THE focus ring (DESIGN_LANGUAGE §8.2, canonical in brand shadow.js +
  // painted globally by brand reset.js). Reference these ONLY where the ring
  // cannot arrive by itself: `focusRing` on the visible proxy of a hidden
  // input; `focusRingInset` on rows inside a clipped container (menu panels,
  // overflow:auto lists) where the outer spread would be cut off. Never
  // restate the value, never an `outline:` ring — that fork was F1.
  focusRing: '0 0 0 1px var(--color-document), 0 0 0 3px var(--color-highlight)',
  focusRingInset: 'inset 0 0 0 1px var(--color-document), inset 0 0 0 3px var(--color-highlight)'
}
